export const stockControlStates = {
    created: 'Created',
    adjusted: 'Adjusted'
}

export const stockControlStatesFormat = {
    Created: 'Creado',
    Adjusted: 'Ajustado'
}

export const stockControlStatesSelect = [
    {
        value: stockControlStates.created,
        label: stockControlStatesFormat.created
    }
]

export const title = 'Controles de Inventario';

export const headers = [
    'Id',
    'Estado',
    'Creado',
];

export const keyColumns = [
    'id',
    'stateToShow',
    'created',
];

export const columns = [
    {
        field: 'id',
        header: 'Id',
        sizes: { xs: 3 }
    },
    {
        field: 'stateToShow',
        header: 'Estado',
        sizes: { xs: 4 }
    },
    {
        field: 'created',
        header: 'Creado',
        type: 'date',
        sizes: { xs: 4 }
    },
];

export const stockControlModel = {
    id: null,
    state: stockControlStates.created,
    details: [],
    created: null,
    updated: null
};